import { render, staticRenderFns } from "./HistorialPaymentActions.vue?vue&type=template&id=40b1e9d4"
import script from "./HistorialPaymentActions.vue?vue&type=script&lang=js"
export * from "./HistorialPaymentActions.vue?vue&type=script&lang=js"
import style0 from "./HistorialPaymentActions.vue?vue&type=style&index=0&id=40b1e9d4&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports